import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { EventDetails } from "./EventDetails";
import { AvatarSelection } from "./AvatarSelection";
import jwtEncode from "jwt-encode";
import axios from "axios";
import Player from "./Player";
import apiClient from "../../apiClient";
import { ENVIRONMENT_DETAIL } from "../../apiClient/apiEndpoints";

export const WebGLPlayer = ({ type, uuid }) => {
  const [banner, setBanner] = useState(null);
  const [currentTab, setCurrentTab] = useState("loading");
  const configData = useSelector((state) => state.configSlice);
  const { config } = configData;
  const userData = useSelector((state) => state.userSlice);
  const [event, setEvent] = useState({});
  const [playerToken, setPlayerToken] = useState(null);

  const updateAvatar = async ({ name, playerAvatar }) => {
    setCurrentTab("loading");
    try {
      let { data } = await axios.post(
        `${config.UNO_URL}/api/auth/player/token`,
        { name, playerAvatar },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );
      const token = jwtEncode(
        {
          token: data.token,
          event: {
            name: event.name,
            uuid: uuid,
            banner: banner ? banner : config.banner,
          },
        },
        ""
      );
      setPlayerToken(token);
    } catch (error) {
      console.log(error);
    }
    setCurrentTab("player");
  };

  const fetchDetails = async () => {
    try {
      if (type == "event") {
        // let { data } = await axios.get(`${config.API_URL}/api/event/details/web/${uuid}`, {
        //   headers: {
        //     Authorization: `Bearer ${userData.token}`,
        //   },
        // });
        let data = await apiClient.get(`${config.API_URL}/api/event/details/web/${uuid}`);
        if (!data) {
          window.location.href = "/";
        } else {
          setEvent(data);
          setCurrentTab("welcome-event");
        }
      } else if (type == "environment") {
        let data = await apiClient.get(`${configData.config.API_URL}${ENVIRONMENT_DETAIL}/web/${uuid}`, {
          headers: {
            Authorization: `Bearer ${userData?.token ? userData?.token : ""}`,
            "Content-Type": "application/json",
          },
        });
        if (!data) {
          window.location.href = "/";
        } else {
          setEvent(data);
          setCurrentTab("welcome-event");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, [type, uuid]);

  const stageRenderer = (currentTab) => {
    switch (currentTab) {
      case "loading":
        return <></>;
      case "avatar-selection":
        return <AvatarSelection setCurrentTab={setCurrentTab} updateAvatar={updateAvatar} />;
      case "welcome-event":
        return <EventDetails setCurrentTab={setCurrentTab} event={event} type={type} />;
      case "unauthorized":
        return (
          <>
            <div className="not-invited">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-exclamation-circle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                </svg>
              </span>
              <p>You are not invited to join this event </p>
              {/* <span className='action-btn' onClick={() => setCurrentTab("avatar-selection")}>Request Access</span> */}
            </div>
          </>
        );
      case "player":
        return <Player playerToken={playerToken} banner={banner} config={config} />;
      default:
        return;
    }
  };
  return (
    <div className="main-event-box">
      {currentTab !== "player" && (
        <>
          <img src={banner ? banner : config.banner} className="bg-event" />
          <span className="shadow">{""}</span>
        </>
      )}
      {stageRenderer(currentTab)}
    </div>
  );
};
